var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"role-badge",attrs:{"variant":_vm.variant}},[_vm._v(_vm._s(_vm.role))])
}
var staticRenderFns = []

export { render, staticRenderFns }